import styled from 'styled-components';
import { Colors } from 'core/CssVariables';

export const SHelpSupportForm = styled.div`
  .ant-form-item {
    margin-bottom: 16px;
  }

  .type-label {
    margin-bottom: 8px;
  }

  .radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }

  .character-count {
    text-align: right;
    color: ${Colors.Grey};
    font-size: 12px;
    margin-top: 4px;
  }

  .character-count-error {
    color: ${Colors.ErrorColor};
  }

  .file-types-hint {
    color: ${Colors.Grey};
    font-size: 12px;
    margin-top: 8px;
  }
`;

export const SSuccessMessage = styled.div`
  text-align: center;
  padding: 24px 0;

  .success-icon {
    margin-bottom: 16px;
  }

  .ticket-link {
    margin-top: 16px;
  }
`;
